import { toggleStyle } from './toggle.css';

type ToggleProps = React.HTMLProps<HTMLDivElement> & {
  children: React.ReactNode;
  css: React.CSSProperties;
};

export const Toggle = ({ children, css, ...props }: ToggleProps) => (
  <div className={toggleStyle} style={css} {...props}>
    {children}
  </div>
);
